import React, { useState } from "react";

import { useTranslation } from "react-i18next";

const data = [
    {
        title: 'tradingtools.10',
    },
    {
        title: 'tradingtools.11',
        switch: [
            {
                question: 'tradingtools.21',
                answer: 'tradingtools.22'
            },
            {
                question: 'tradingtools.23',
                answer: 'tradingtools.24'
            }
        ]
    },
    {
        title: 'tradingtools.12',
        switch: [
            {
                question: 'tradingtools.26',
                answer: 'tradingtools.27'
            },
            {
                question: 'tradingtools.28',
                answer: 'tradingtools.29'
            },
            {
                question: 'tradingtools.30',
                answer: 'tradingtools.31'
            },
            {
                question: 'tradingtools.32',
                answer: 'tradingtools.33'
            },
        ]
    },
    {
        title: 'tradingtools.13',
        switch: [
            {
                question: 'tradingtools.35',
                answer: 'tradingtools.36'
            },
            {
                question: 'tradingtools.37',
                answer: 'tradingtools.38'
            },
            {
                question: 'tradingtools.39',
                answer: 'tradingtools.40'
            },
        ]
    },
]

function Switcher () {

    const { t } = useTranslation();

    const [active, setActive] = useState(0);

    const [openIndex, setOpenIndex] = useState(1);

    const toggleText = (index) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };
    
    return(
        <div className="relative overflow-hidden pt-[80px] xl:pt-[160px]">
             <div className="max-w-[1280px] mx-[20px] xl:mx-auto flex flex-wrap justify-between gap-[20px]">
                {data.map((slide, index) => (
                    <div className={`cursor-pointer flex items-center justify-center flex-grow px-[20px] py-[20px] transition-all ${active === index ? 'bg-[#B30101]' : 'bg-[#ECECEC]'}`} key={index} onClick={() => setActive(index)}>
                        <p className={`manrope text-[16px] xl:text-[20px] font-[500] leading-[1.2] transition-all ${active === index ? 'text-white' : 'text-[#B30101]'}`}>{t(slide.title)}</p>
                    </div>
                ))}
            </div>
            <div className="max-w-[1280px] xl:mx-auto mx-[20px] mt-[20px] xl:mt-[60px]">
                {active === 0 ? 
                    <div className="flex flex-col md:flex-row justify-between">
                        <div className="md:max-w-[350px] xl:max-w-[562px]">
                            <p className="manrope text-[20px] xl:text-[40px] leading-[1.2] font-[500]">{t('tradingtools.10')}</p>
                            <p className="roboto text-[14px] xl:text-[16px] font-[300] mt-[20px] xl:mt-[40px] text-[#000000B2]">{t('tradingtools.14')}</p>
                        </div>
                        <div className="max-w-[562px] mt-[20px] xl:mt-0">
                            <p className="roboto text-[16px] xl:text-[20px] font-[400] text-[#000000B2]">{t('tradingtools.15')}</p>
                            <div className="flex items-start gap-[18px]">
                                <svg className="flex-shrink-0 mt-[20px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M9.75171 6.09415L0.610946 11.3716L0.610948 0.816723L9.75171 6.09415Z" fill="#B30101"/>
                                </svg>
                                <p className="roboto text-[14px] xl:text-[16px] font-[400] mt-[15px] text-[#000000B2]">{t('tradingtools.16')}</p>
                            </div>
                            <div className="flex items-start gap-[18px]">
                                <svg className="flex-shrink-0 mt-[20px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M9.75171 6.09415L0.610946 11.3716L0.610948 0.816723L9.75171 6.09415Z" fill="#B30101"/>
                                </svg>
                                <p className="roboto text-[14px] xl:text-[16px] font-[400] mt-[15px] text-[#000000B2]">{t('tradingtools.17')}</p>
                            </div>
                            <div className="flex items-start gap-[18px]">
                                <svg className="flex-shrink-0 mt-[20px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M9.75171 6.09415L0.610946 11.3716L0.610948 0.816723L9.75171 6.09415Z" fill="#B30101"/>
                                </svg>
                                <p className="roboto text-[14px] xl:text-[16px] font-[400] mt-[15px] text-[#000000B2]">{t('tradingtools.18')}</p>
                            </div>
                            <div className="flex items-start gap-[18px]">
                                <svg className="flex-shrink-0 mt-[20px]" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M9.75171 6.09415L0.610946 11.3716L0.610948 0.816723L9.75171 6.09415Z" fill="#B30101"/>
                                </svg>
                                <p className="roboto text-[14px] xl:text-[16px] font-[400] mt-[15px] text-[#000000B2]">{t('tradingtools.19')}</p>
                            </div>
                        </div>
                    </div> 
                : null}
                {active === 1 ? 
                    <div className="flex flex-col md:flex-row justify-between md:gap-[100px]">
                        <div className="md:max-w-[350px] xl:max-w-[562px]">
                            <p className="manrope text-[20px] xl:text-[40px] leading-[1.2] font-[500]">{t('tradingtools.11')}</p>
                            <p className="roboto text-[14px] xl:text-[16px] font-[300] mt-[20px] xl:mt-[40px] text-[#000000B2]">{t('tradingtools.20')}</p>
                        </div>
                        <div className="w-full">
                            {data[active].switch.map((faq, index) => (
                                <div key={index}>
                                    <div className={`flex justify-between transition-all duration-300 ${openIndex === index ? 'h-auto' : 'h-[86px]'}`}>
                                        <div>
                                            <p className='mt-[25px] manrope text-[20px] xl:text-[24px] text-[#000000] max-w-[200px] xl:max-w-[1280px]'>{t(faq.question)}</p>
                                            {openIndex === index && (
                                                <p className='text-[#000000B2] roboto text-[14px] xl:text-[17px] font-light mt-[12px] pb-[20px] max-w-[200px] xl:max-w-[802px]'>{t(faq.answer)}</p>
                                            )}
                                        </div>
                                        <div className='cursor-pointer mt-[30px] flex-shrink-0' onClick={() => toggleText(index)}>
                                            <svg className={` transition-all ${openIndex === index ? 'rotate-90' : 'rotate-0'}`} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                <rect x="1" y="1" width="30" height="30" fill="#B30101" stroke="#B30101" stroke-width="2"/>
                                                <path d="M24.7071 16.7071C25.0976 16.3166 25.0976 15.6834 24.7071 15.2929L18.3431 8.92893C17.9526 8.53841 17.3195 8.53841 16.9289 8.92893C16.5384 9.31946 16.5384 9.95262 16.9289 10.3431L22.5858 16L16.9289 21.6569C16.5384 22.0474 16.5384 22.6805 16.9289 23.0711C17.3195 23.4616 17.9526 23.4616 18.3431 23.0711L24.7071 16.7071ZM8 17L24 17V15L8 15V17Z" fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="h-[1px] w-full bg-[#000000B2]"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                : null}
                {active === 2 ? 
                    <div>
                        <p className="manrope text-[20px] xl:text-[40px] leading-[1.2] font-[500]">{t('tradingtools.12')}</p>
                        <p className="roboto text-[14px] xl:text-[16px] font-[300] mt-[20px] xl:mt-[40px] text-[#000000B2] max-w-[562px]">{t('tradingtools.25')}</p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-[100px] xl:mt-[30px]">
                            {data[active].switch.map((faq, index) => (
                                <div key={index}>
                                    <div className={`flex justify-between transition-all duration-300 ${openIndex === index ? 'h-auto' : 'h-[86px]'}`}>
                                        <div>
                                            <p className='mt-[25px] manrope text-[20px] xl:text-[24px] text-[#000000] max-w-[200px] xl:max-w-[1280px]'>{t(faq.question)}</p>
                                            {openIndex === index && (
                                                <p className='text-[#000000B2] roboto text-[14px] xl:text-[17px] font-light mt-[12px] pb-[20px] max-w-[200px] xl:max-w-[802px]'>{t(faq.answer)}</p>
                                            )}
                                        </div>
                                        <div className='cursor-pointer mt-[30px] flex-shrink-0' onClick={() => toggleText(index)}>
                                            <svg className={` transition-all ${openIndex === index ? 'rotate-90' : 'rotate-0'}`} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                <rect x="1" y="1" width="30" height="30" fill="#B30101" stroke="#B30101" stroke-width="2"/>
                                                <path d="M24.7071 16.7071C25.0976 16.3166 25.0976 15.6834 24.7071 15.2929L18.3431 8.92893C17.9526 8.53841 17.3195 8.53841 16.9289 8.92893C16.5384 9.31946 16.5384 9.95262 16.9289 10.3431L22.5858 16L16.9289 21.6569C16.5384 22.0474 16.5384 22.6805 16.9289 23.0711C17.3195 23.4616 17.9526 23.4616 18.3431 23.0711L24.7071 16.7071ZM8 17L24 17V15L8 15V17Z" fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="h-[1px] w-full bg-[#000000B2]"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                : null}
                {active === 3 ? 
                    <div className="flex flex-col md:flex-row justify-between md:gap-[100px]">
                        <div className="max-w-[562px]">
                            <p className="manrope text-[20px] xl:text-[40px] leading-[1.2] font-[500]">{t('tradingtools.13')}</p>
                            <p className="roboto text-[14px] xl:text-[16px] font-[300] mt-[20px] xl:mt-[40px] text-[#000000B2]">{t('tradingtools.34')}</p>
                        </div>
                        <div className="w-full">
                            {data[active].switch.map((faq, index) => (
                                <div key={index}>
                                    <div className={`flex justify-between transition-all duration-300 ${openIndex === index ? 'h-auto' : 'h-[86px]'}`}>
                                        <div>
                                            <p className='mt-[25px] manrope text-[20px] xl:text-[24px] text-[#000000] max-w-[200px] xl:max-w-[1280px]'>{t(faq.question)}</p>
                                            {openIndex === index && (
                                                <p className='text-[#000000B2] roboto text-[14px] xl:text-[17px] font-light mt-[12px] pb-[20px] max-w-[200px] xl:max-w-[802px]'>{t(faq.answer)}</p>
                                            )}
                                        </div>
                                        <div className='cursor-pointer mt-[30px] flex-shrink-0' onClick={() => toggleText(index)}>
                                            <svg className={` transition-all ${openIndex === index ? 'rotate-90' : 'rotate-0'}`} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                <rect x="1" y="1" width="30" height="30" fill="#B30101" stroke="#B30101" stroke-width="2"/>
                                                <path d="M24.7071 16.7071C25.0976 16.3166 25.0976 15.6834 24.7071 15.2929L18.3431 8.92893C17.9526 8.53841 17.3195 8.53841 16.9289 8.92893C16.5384 9.31946 16.5384 9.95262 16.9289 10.3431L22.5858 16L16.9289 21.6569C16.5384 22.0474 16.5384 22.6805 16.9289 23.0711C17.3195 23.4616 17.9526 23.4616 18.3431 23.0711L24.7071 16.7071ZM8 17L24 17V15L8 15V17Z" fill="white"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="h-[1px] w-full bg-[#000000B2]"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                : null}
            </div>
        </div>
    );
}

export default Switcher;